import { Component } from '@angular/core';
import { FirebaseApp } from 'angularfire2';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'app works!';

  constructor(fbA: FirebaseApp){
    console.log(fbA);
    
  }
}



// WEBPACK FOOTER //
// /Users/aubreyfletcher/Desktop/projects/node/node_projects/ng5/cashfletcher_videoPlayer/src/app/app.component.ts